import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  info: {
    height: 24,
    width: 24,
    paddingLeft: 2,
    cursor: 'pointer'
  },
  smallIcon: {
    height: 14,
    width: 14,
    marginLeft: 5,
    cursor: 'pointer'
  },
  icon16: {
    height: 16,
    width: 16,
    marginLeft: 5,
    cursor: 'pointer'
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 24
  },
  tooltip: ({ size }) => ({
    margin: theme.spacing(0, 1),
    backgroundColor: theme.colorPalette.green_10,
    fontSize: size === 'small' ? 10 : 14
  }),
  labelWrapper: ({ height }) => ({
    zIndex: 98,
    height: height || 'unset'
  }),
  desktopLabel: {
    fontSize: 10,
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    color: theme.palette.secondary.main,
    textTransform: 'none',
    fontFamily: 'Libre Franklin',
    cursor: 'pointer'
  },
  labelNextToText: {
    paddingLeft: theme.spacing(2)
  },
  formField: {
    position: 'absolute',
    padding: theme.spacing(1),
    right: theme.spacing(2),
    top: theme.spacing(-0.5)
  }
});

export default makeStyles(styles);
